import { DocumentType } from '../types/document-revision-status.types';

/**
 * Segmento que separa as duas naturezas na rota de detalhe.
 *
 * `/aprovacao/61` sozinho é ambíguo: 61 pode ser uma revisão de documento **e** uma matriz, porque
 * as duas tabelas têm sequência própria. O segmento resolve isso sem depender de um parâmetro de
 * consulta, que some de uma busca compartilhada ou de um link copiado pela metade. O segmento é
 * opcional na rota, para os links antigos continuarem abrindo o documento: uma URL sem ele é a
 * natureza documento, e não uma natureza desconhecida.
 */
export const HOMOLOGATION_RECORD_SEGMENT = 'registro';

export type HomologationDetailBasePath = '/aprovacao' | '/verificacao';

export function buildHomologationDetailPath(
  basePath: HomologationDetailBasePath,
  id: number | string,
  documentType?: string
): string {
  return documentType === DocumentType.REGISTRATION
    ? `${basePath}/${HOMOLOGATION_RECORD_SEGMENT}/${id}`
    : `${basePath}/${id}`;
}

/** Lê o segmento da rota de detalhe: é ele que decide a fonte antes de qualquer chamada. */
export function isRecordDetailRoute(nature: unknown): boolean {
  return nature === HOMOLOGATION_RECORD_SEGMENT;
}

export function buildHomologationListRoute(
  basePath: string,
  isRecord: boolean
): { path: string; query: { type: DocumentType } } {
  return {
    path: basePath,
    query: { type: isRecord ? DocumentType.REGISTRATION : DocumentType.DOCUMENT },
  };
}
